"use strict";

import axios from "@/plugins/axios";

export const dashboard = {
  namespaced: true,
  state: {
    data: {}
  },
  getters: {
    getData: state => state.data
  },
  mutations: {
    UPDATE_DATA: (state, payload) => (state.data = payload)
  },
  actions: {
    async getData({ commit }) {
      try {
        let data = (await axios.get("/api/dashboard")).data;
         
        commit("UPDATE_DATA", data.data);
      } catch (error) {
        return error
         
      }
    }
  }
};
